import { render, staticRenderFns } from "./PrebuiltGridAction.vue?vue&type=template&id=3ddd49a5&scoped=true&"
import script from "./PrebuiltGridAction.vue?vue&type=script&lang=js&"
export * from "./PrebuiltGridAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddd49a5",
  null
  
)

export default component.exports